/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Frontrow_Step_ConfirmedInputs */

const en_scene_frontrow_step_confirmed = /** @type {(inputs: Scene_Frontrow_Step_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmed`)
};

/**
* | output |
* | --- |
* | "Confirmed" |
*
* @param {Scene_Frontrow_Step_ConfirmedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_frontrow_step_confirmed = /** @type {((inputs?: Scene_Frontrow_Step_ConfirmedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Frontrow_Step_ConfirmedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_frontrow_step_confirmed(inputs)
});